<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/storeCost/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/storeCost/index', 'create')" size="small" type="primary"
            class="el-icon-plus" @click="handleEdit()">新增
          </el-button>
        </el-form-item>
        <el-form-item class="view-toggle" style="float: right;">
          <el-button-group>
            <el-button size="small" :type="viewMode === 'card' ? 'primary' : 'default'" @click="toggleView('card')" title="卡片视图">
              <i class="el-icon-s-grid"></i>
            </el-button>
            <el-button size="small" :type="viewMode === 'list' ? 'primary' : 'default'" @click="toggleView('list')" title="列表视图">
              <i class="el-icon-s-unfold"></i>
            </el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
      <!-- 列表视图 -->
      <STable v-if="viewMode === 'list'" :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border stripe>
      </STable>
      <!-- 卡片视图 -->
      <div v-else class="card-view">
        <div class="card-grid">
          <div class="card-item" v-for="(item, index) in listData" :key="index">
            <el-card class="cost-card" shadow="hover">
              <div slot="header" class="card-header">
                <span class="store-name">{{ item.storeName }}</span>
                <el-tag size="mini" type="success">备用金</el-tag>
              </div>
              <div class="card-body">
                <div class="stat-row">
                  <span class="label">备用金余额</span>
                  <span class="value primary">¥{{ item.remainingCost || 0 }}</span>
                </div>
                <div class="stat-row">
                  <span class="label">总下发备用金</span>
                  <span class="value">¥{{ item.totalCost || 0 }}</span>
                </div>
                <div class="stat-row">
                  <span class="label">备用金总支出</span>
                  <span class="value warning">¥{{ item.totalExpense || 0 }}</span>
                </div>
                <div class="stat-row">
                  <span class="label">创建人</span>
                  <span class="value">{{ item.creator || '-' }}</span>
                </div>
                <div class="stat-row">
                  <span class="label">创建时间</span>
                  <span class="value time">{{ item.createTime || '-' }}</span>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <div v-if="listData.length === 0" class="empty-card">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 编辑 -->
    <edit ref="edit"></edit>
  </div>
</template>

<script>
import {
  GetStoreCostMainPageList
} from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import edit from "./edit.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "门店备用金",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      viewMode: "card", // 默认卡片视图
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        storeKeyId: "",
      },
      storeList: [],
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          minWidth: "120",
          align: "center",
        },
        {
          prop: "remainingCost",
          label: "备用金余额",
          minWidth: "100",
          align: "center",
        },
        {
          prop: "totalCost",
          label: "总下发备用金",
          minWidth: "120",
          align: "center",
        },
        {
          prop: "totalExpense",
          label: "备用金总支出",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "170",
          align: "center",
        },
      ],
    };
  },
  // 注册组件
  components: {
    edit,
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetOrgInfoListByConfig();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            res.data.forEach((item) => {
              this.storeList.push({
                keyId: item.keyId,
                value: item.name + '【' + item.remark2 + '】',
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    //显示编辑界面
    handleEdit(row) {
      this.$refs.edit.editShow(row);
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetStoreCostMainPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 切换视图
    toggleView(mode) {
      this.viewMode = mode;
    },
  },
};
</script>

<style scoped>
.view-toggle {
  float: right;
}
.card-view {
  margin-top: 16px;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}
.card-item {
  min-width: 0;
}
.cost-card {
  border-radius: 8px;
  margin-bottom: 16px;
  transition: all 0.3s ease;
}
.cost-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.cost-card >>> .el-card__header {
  padding: 12px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}
.cost-card >>> .el-card__body {
  padding: 16px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.store-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.card-body {
  margin-bottom: 12px;
}
.stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}
.stat-row:last-child {
  border-bottom: none;
}
.stat-row .label {
  font-size: 13px;
  color: #64748b;
}
.stat-row .value {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.stat-row .value.primary {
  color: #409eff;
  font-size: 16px;
}
.stat-row .value.warning {
  color: #e6a23c;
}
.stat-row .value.time {
  font-size: 12px;
  color: #909399;
}
.empty-card {
  padding: 40px 0;
  text-align: center;
}
</style>